export { default } from './gtm-always-on-listener';
